import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Button, Accordion } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetCourseQuery, useSaveActiveLessonMutation } from '../../slices/teachers/courseApiSlice';            
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import VideoJS from '../../components/VideoJs';
import Subject from '../../components/Subject';
import StudentSubject from '../../components/StudentSubject';
import NoSubject from '../../components/NoSubject';
import PaginateNewAnswers from '../../components/PaginateNewAnswers';
import { colors44 } from '../../colorConstant';

const StudentWatchCourse = () => {

    const playerRef = useRef(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }   
    }, [navigate, studentInfo])

    const [name, setName] = useState('');
    const [lessonsBySection, setLessonsBySection] = useState([]);   
    const [subjectId, setSubjectId] = useState();
    const [activeLesson, setActiveLesson] = useState(null);
    const [loading, setLoading] = useState(false);
    const [activeSection, setActiveSection] = useState();

    const { data, error, isLoading, refetch } = useGetCourseQuery(id);
    const [ saveActiveLesson ] = useSaveActiveLessonMutation();

    const goToQuestion = () => {
         window.open(`${window.location.origin}/studentaskdetails/${subjectId}`, '_blank')
      }
    
    useEffect(() => {
        setName(data?.name);
        setSubjectId(data?.subject)
        const groupedLessons = data?.lessons.reduce((acc, lesson) => {
            if (!acc[lesson.sectionNumber]) {
                acc[lesson.sectionNumber] = [];
            }
            acc[lesson.sectionNumber].push(lesson);
            return acc;
        }, []);
        groupedLessons?.forEach(section => {
            section.sort((a, b) => a.lessonNumber - b.lessonNumber);
        });
        setLessonsBySection(groupedLessons);
    }, [data]);

    useEffect(() => {
        if (lessonsBySection?.length > 0 && studentInfo) {
            const courseActive = studentInfo.courseActive || [];
            const activeCourse = courseActive.find(c => c.course === id);
            if (activeCourse && activeCourse.activeLesson) {
                const foundLesson = data?.lessons.find(lesson => lesson._id === activeCourse.activeLesson._id);
                if (foundLesson) {
                    setActiveLesson(foundLesson);
                    setActiveSection(foundLesson.sectionNumber);
                } else {
                    setActiveLesson(lessonsBySection[1][0]);
                    setActiveSection(lessonsBySection[1][0].sectionNumber);
                }
            } else {
                setActiveLesson(lessonsBySection[1][0]);
                setActiveSection(lessonsBySection[1][0].sectionNumber);
            }
        }       
      }, [lessonsBySection, studentInfo]); 

    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{
          src: `https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/lessons/${activeLesson?.mediaId}`,
          type: 'video/mp4'
        }]
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        player.on('waiting', () => {});
        player.on('dispose', () => {});
    };
        
   const videoHandler = async (lesson) => {
        setLoading(true);
        setActiveLesson(lesson)
        const res = await saveActiveLesson({lesson, id }).unwrap()
        dispatch(setStudentCredentials({ ...res }));
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    return (
        <div>
            <StudentNavbar />
            <div className="main-content" id="panel">
                <StudentHeader /><br />
                <div className="">
                    {isLoading ? ( 
                        <Loader />
                    ) : error ? (
                        <Message variant='danger'>
                            {error?.data?.message || error.error}
                        </Message>
                    ) : (
                    <>
                        <div className="row">
                            <div  className="col-sm-7">
                                <h3 className="centerTitle tittleColor4 courseTitle2">
                                    <span className='courseTitle' style={{textTransform: 'capitalize'}}>
                                    {name}
                                    </span>
                                </h3>
                            </div>
                        </div>
                        <div className="row ">
                            <div  className=" col-xl-7 courseAccord">
                                {!loading ? (
                                <>                       
                                    <VideoJS 
                                      options={videoJsOptions} 
                                      onReady={handlePlayerReady} 
                                      cssRule="card-img-top lessonVid"
                                    />
                                     {/* <video autoplay controls className="card-img-top lessonVid">      
                                                    <source 
                                                        src={`https://ask2l.s3.us-east-2.amazonaws.com/public/lessons/${activeLesson?.mediaId}`} 
                                                        type="video/mp4"
                                                    />
                                    </video> */}
                                <br /><br />                                                     
                                <div className='mycard'>
                                    <Button   type='submit' variant="info rounded-pill bg-gradient-info btn-lg lessonAsk3 "
                                     onClick={goToQuestion}> 
                                        Ask me a Question 
                                    </Button>
                                </div>
                                </>                    
                                ) : (     
                                    <>             
                                        <br /><br /><br /><br />
                                        <Loader className="load2" />
                                    </>
                                )}   
                            </div>                         
                            <div className="offset-xl-2  col-xl-3">   
                                {activeSection && (
                                <Accordion defaultActiveKey={activeSection} className='accord'>
                                    {lessonsBySection?.map((sec, sectionIndexx) => (
                                        <div key={sectionIndexx}>
                                            {sec.map((lesson, lessonIndex) => (
                                                <>
                                                <Accordion.Item eventKey={`${sectionIndexx}`}>
                                                    {lessonIndex === 0 && (                                                    
                                                    <Accordion.Header className=''>
                                                         <p className='courseSection'>
                                                        Section {sectionIndexx}: {lesson.section}
                                                        </p>
                                                    </Accordion.Header>                                                
                                                    )}
                                                    <Accordion.Body 
                                                    className={lesson === activeLesson ? "activee" : ""} 
                                                    >
                                                    <p onClick={() => videoHandler(lesson)} style={{ cursor: "pointer" }}>
                                                    <i className="ni ni-button-play  LessonPlay"></i> 
                                                    <span className='lessonT'>
                                                    {lesson.title} 
                                                    </span>
                                                    </p>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                </>
                                            ))}
                                        </div>
                                    ))}
                                </Accordion>                   
                                )}
                            </div>                   
                        </div>
                    </>
                    )} 
                </div>
            </div>
        </div>
    )
}

export default StudentWatchCourse
